module.exports = __webpack_public_path__ + "static/media/PB_G_13.b662fc41.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/progress_bar/green/PB_G_13.png
// module id = 226
// module chunks = 0